/* src/app/modules/spare-parts/part-status-info/part-status-info.component.scss */
:host {
  display: flex;
  max-width: 5.125rem;
  height: var(--sh-tag-container-height);
}
.part-status {
  flex: 1;
  padding: 0.375rem 0.5rem;
  border: var(--sh-tag-wrapper-border) solid black;
  border-radius: var(--sh-tag-border-radius);
  text-align: center;
  line-height: 1.25rem;
  align-content: center;
}
.part-status--ordered {
  border-color: rgba(var(--ui-2), var(--opacity-5));
}
.part-status--consumed {
  border-color: rgb(var(--ui-5), var(--opacity-5));
}
.part-status--none {
  border: none;
}
/*# sourceMappingURL=part-status-info.component.css.map */
